export type PaymentOutcome = "FULL" | "PARTIAL" | "OVERPAYMENT";

export type PaymentFieldErrors = {
  amount?: string;
  method?: string;
  receivedDate?: string;
  chequeNumber?: string;
  cardLast4?: string;
};

export function classifyPaymentOutcome(
  amountCents: number,
  balanceDue: number,
): PaymentOutcome {
  if (amountCents > balanceDue) return "OVERPAYMENT";
  if (amountCents < balanceDue) return "PARTIAL";
  return "FULL";
}

export function getPaymentFieldErrors(input: {
  amountCents: number;
  method: string;
  receivedDate?: string;
  chequeNumber?: string;
  cardLast4?: string;
  isZeroBalance?: boolean;
  balanceDue?: number;
}): PaymentFieldErrors {
  const errors: PaymentFieldErrors = {};
  const isComplimentary = input.method === "COMPLIMENTARY";

  if (!input.method?.trim()) {
    errors.method = "Payment method is required";
  }

  if (isComplimentary) {
    if (input.isZeroBalance) {
      if (input.amountCents !== 0) {
        errors.amount = "Complimentary payments must be $0.00";
      }
    } else if (input.amountCents !== input.balanceDue) {
      errors.amount =
        "Complimentary must cover the full outstanding balance";
    }
    return errors;
  }

  if (!Number.isSafeInteger(input.amountCents) || input.amountCents <= 0) {
    errors.amount = "Enter a valid payment amount";
  }
  if (!input.receivedDate?.trim()) {
    errors.receivedDate = "Received date is required";
  }
  if (input.method === "CHEQUE" && !input.chequeNumber?.trim()) {
    errors.chequeNumber = "Cheque number is required";
  }
  if (input.cardLast4 && !/^\d{4}$/.test(input.cardLast4)) {
    errors.cardLast4 = "Enter only the last four card digits";
  }
  return errors;
}

export function validatePaymentFields(input: {
  amountCents: number;
  method: string;
  receivedDate?: string;
  chequeNumber?: string;
  cardLast4?: string;
  isZeroBalance?: boolean;
  balanceDue?: number;
}): string | null {
  const errors = getPaymentFieldErrors(input);
  return (
    errors.amount ??
    errors.method ??
    errors.receivedDate ??
    errors.chequeNumber ??
    errors.cardLast4 ??
    null
  );
}
